import { NgModule } from '@angular/core';

import { JornadasComponent } from './jornadas.component';

import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';

@NgModule({
  declarations: [
    JornadasComponent
  ],
  imports: [
    TranslateModule,
    CommonModule
  ],
  exports: [
    JornadasComponent
  ]
})

export class JornadasModule { }
